module.exports = __webpack_public_path__ + "header-logo-61babf58725479d4be87955ed871f81e.svg";